import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { includes, map } from 'lodash';
import Tippy from '@tippy.js/react';
import { IconInfo } from 'svgIcons/MotionPortalIcons';
import { EventTypeGatewayApplicability, EventTypeIDs, EventTypes } from '../constants';
import { Col, Container, Row } from 'react-bootstrap';
import './style.scss';

const GatewayEventTypeFilter = ({
    selectedStates,
    selectState,
    gatewayEventLogType = EventTypeGatewayApplicability.ALL,
    disabled = false,
    showLabels = false,
    showInfoIcon = true
}) => {
    const { t: translate } = useTranslation();
    const eventTypes = EventTypes.filter(eventType => {
        if (gatewayEventLogType === EventTypeGatewayApplicability.SMART_SENSOR_DCU) {
            // SmartSensor DCU: show DEBUG, WARNING, INFO — exclude FAULT
            return eventType.applicableTo === EventTypeGatewayApplicability.SMART_SENSOR_DCU ||
                eventType.applicableTo === EventTypeGatewayApplicability.ALL && eventType.typeID !== EventTypeIDs.FAULT;
        }
        // All other tabs: show FAULT, WARNING, INFO — exclude DEBUG
        return eventType.applicableTo === EventTypeGatewayApplicability.ALL ||
            eventType.applicableTo === gatewayEventLogType;
    });

    const renderEventTypeLabels = () => {
        return map(eventTypes, (eventType, index) =>
            <Row key={index} className='event-list-filter-tippy-content'>
                <Col md='auto' className='pr-1'>
                    {eventType.icon}
                </Col>
                <Col className='event-list-filter-tippy-label p-0'>
                    {translate(eventType.label)}
                </Col>
            </Row>
        );
    };

    // Helper function to render a single event type button
    const renderEventTypeButton = (eventType) => {
        const isSelected = includes(selectedStates || [], eventType.typeID);
        const buttonClass = `event-type${isSelected ? ' selected' : ''}${showLabels ? ' event-type-label' : ''}`;
        const handleClick = () => {
            if (!disabled) {
                selectState(eventType.typeID);
            }
        };

        return (
            <button
                className={buttonClass}
                onClick={handleClick}
                key={eventType.typeID}
                disabled={disabled}
                title={translate(eventType.label)}
            >
                {showLabels ? translate(eventType.label) : eventType.icon}
            </button>
        );
    };

    const renderEventTypeButtons = () => {
        return map(eventTypes, (eventType) => renderEventTypeButton(eventType));
    };

    const renderTooltipContent = () => {
        return <Container>
            <Row className='event-list-filter-tippy-title'>
                <Col>{translate('ABB.Powertrain.Frontend.eventListFilterEventTypesLbl')}</Col>
            </Row>
            {renderEventTypeLabels()}
        </Container>;
    };

    return (
        <div className='event-type-filter'>
            <div className='event-types'>
                {renderEventTypeButtons()}
                {!showLabels && showInfoIcon && <Tippy
                    content={renderTooltipContent()}
                    className='event-type-filter-info-tippy'
                    interactive={true}
                    animation='scale'
                    theme='light-border'
                    trigger='click'
                    placement='bottom'
                    popperOptions={{
                        modifiers: {
                            preventOverflow: {
                                escapeWithReference: true
                            }
                        }
                    }}
                >
                    <div className='info-icon-wrapper'>
                        <IconInfo color={'black'} />
                    </div>
                </Tippy>}
            </div>
        </div>
    );
};

GatewayEventTypeFilter.propTypes = {
    selectedStates: PropTypes.array,
    selectState: PropTypes.func.isRequired,
    gatewayEventLogType: PropTypes.number,
    disabled: PropTypes.bool,
    showLabels: PropTypes.bool,
    showInfoIcon: PropTypes.bool
};

export default GatewayEventTypeFilter;

